<template>
  <div class="neuter">
      <!-- 口号标题 -->
    <div class="slogan" v-if="carousel">
        <img src="/photo/icon/slogan.png" alt="标题">
    </div>
    <!-- 提示框 -->
    <div class="prompt" v-if="carousel">
        <img class="prompt-img" :src="hintIcon.tooltipIcon" alt="提示">
        <div class="desc-prompt">
            <p>
                <strong>{{tooltip.title1}}：</strong><span>{{tooltip.desc1}}</span>
            </p>
            <p class="desc">
                <strong>{{tooltip.title2}}：</strong>
                <span>{{tooltip.desc2}}</span>
                <span class="account-prompt">{{tooltip.desc3}}</span>
            </p>
        </div>
    </div>
    <div class="second-home">
        <div class="download-content">
            <!-- 图片轮播 -->
            <div class="carousel" v-if="carousel">
                <el-carousel height="400px" arrow="never">
                    <el-carousel-item
                        v-for="item in carouselImg"
                        :key="item.id">
                        <img :src="item.img" :alt="item.value">
                    </el-carousel-item>
                </el-carousel>
            </div>
            <!-- 软件信息 -->
            <div :class="[!carousel?'change-carousel':'', 'content']">
                <div class="title">
                    {{softwareInfo.title}}
                </div>
                <div class="second-title">
                    {{softwareInfo.subtitle}}
                </div>
                <div class="system">
                    {{softwareInfo.system}}
                </div>
                <div class="prompt1">
                    {{softwareInfo.desc}}
                </div>
                <!-- 下载按键 -->
                <div class="btn">
                    <!-- 单机版 -->
                    <a
                        class="stand-alone"
                        :href="softwareInfo.softwareName1"
                        target="_blank">
                        <div class="version-type">
                            <div class="desc">{{softwareInfo.type1}}</div>
                            <img :src="hintIcon.downloanIcon" alt="下载">
                        </div>
                        <div class="version">
                            {{softwareInfo.version1}}
                        </div>
                    </a>
                    <!-- 云服务版 -->
                    <a
                        class="cloud"
                        :href="softwareInfo.softwareName2"
                        target="_blank">
                        <div class="version-type">
                            <div class="desc">{{softwareInfo.type2}}</div>
                            <img :src="hintIcon.downloanIcon" alt="下载">
                        </div>
                        <div class="version">
                            {{softwareInfo.version2}}
                        </div>
                    </a>
                </div>
                <!-- 小程序 -->
                <img class="applets" :src="applets" alt="小程序">
                <!-- 密码提示 -->
                <!-- <div class="remark">{{softwareInfo.password}}</div> -->
                <a
                    class="remark"
                    :href="softwareInfo.environment"
                    target="_blank">
                    .NET Framework4.0 <span>下载</span>
                </a>
                <!-- 视频教程 -->
                <div class="teaching-video">
                    <a
                        class="left"
                        :href="softwareInfo.cradleURL"
                        target="_blank">
                        {{softwareInfo.videoDesc1}}
                        <img :src="hintIcon.videoIcon" alt="播放">
                    </a>
                    <a
                        class="right"
                        :href="softwareInfo.lineURL"
                        target="_blank">
                        {{softwareInfo.videoDesc2}}
                        <img :src="hintIcon.videoIcon" alt="播放">
                    </a>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
// import axios from 'axios'
export default {
    name: 'Neuter',
    data () {
        return {
            // 时间戳
            timeStamp: 0,
            // 控制轮播的显示或者隐藏
            carousel: true,
            left: document.documentElement.clientWidth,
            top: window.innerHeight,
            // 提示框信息
            tooltip: {},
            // 软件信息
            softwareInfo: {},
            // 轮播图片列表
            carouselImg: [],
            // 小程序图片
            applets: '',
            // 提示-下载-播放图标
            hintIcon: '',
        }
    },
    computed: {
        width () {
            return {
                width: `${this.left}px`
            }
        },
        height () {
            return {
                height: `${this.top}px`
            }
        }
    },
    created () {
        // 获取时间戳
        this.getTimeStamp()
        this.obtainData()
        this.hideCarousel()
    },
    mounted () {
        window.addEventListener('resize', this.resize)
    },
    methods: {
        // 获取时间戳
        getTimeStamp () {
            this.timeStamp = new Date().getTime()
            // console.log(this.timeStamp)
        },
        // 获取静态json数据
        obtainData () {
            this.$http.get('/mock/znzuan.json', {
                params: {
                    timeStamp: this.timeStamp
                }
            })
                .then((res) => {
                    this.tooltip = res.data.data.tooltip
                    this.softwareInfo = res.data.data.softwareInfo
                    this.carouselImg = res.data.data.carousel
                    this.applets = res.data.data.applets
                    this.hintIcon = res.data.data.icon
                })
        },
        // 动态监测页面大小
        resize () {
            var screenwidth = document.documentElement.clientWidth
            var sceenheight = window.innerHeight
            this.left = screenwidth
            this.top = sceenheight
            this.hideCarousel()
        },
        // 判断轮播是否显示方法
        hideCarousel () {
            var screenwidth = document.documentElement.clientWidth
            if (screenwidth < 500) {
                this.carousel = false
            } else {
                this.carousel = true
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.neuter {
	height: 100vh;
	background: #409EFF;
	display: flex;
	flex-direction: column;
    justify-content: center;
	align-items: center;
    .slogan {
        margin-bottom: 5px;
        img {
            width: auto;
            height: 100px;
        }
    }
    .prompt {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: 35px;
        width: 1000px;
        height: 65px;
        background: #fff;
        border-radius: 10px;
        .prompt-img {
            margin: 0 10px;
            width: 50px;
            height: 50px;
        }
        .desc-prompt {
            margin-right: 10px;
            p {
                color: #409eff;
                font-size: 18px;
                span {
                    font-size: 16px;
                }
                .account-prompt {
                    font-weight: bold;
                    color: #ff0000;
                    letter-spacing: 1px;
                }
            }
            .desc {
                margin-top: 3px;
            }
        }
    }
    .second-home {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .download-content {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            width: 980px;
            .carousel {
                width: 600px;
                img {
                    width: 600px;
                    height: 400px;
                    border-radius: 2px;
                }
            }
            .content {
                flex: 1;
                display: flex;
                flex-direction: column;
                align-items: center;
                margin-left: 30px;
                white-space: nowrap;
                overflow: hidden;
                .title {
                    height: 40px;
                    line-height: 40px;
                    color: #fff;
                    font-size: 35px;
                    letter-spacing: 2px;
                    font-weight: bold;
                }
                .second-title {
                    margin-top: 5px;
                    height: 25px;
                    line-height: 25px;
                    color: #fff;
                    font-size: 30px;
                    letter-spacing: 2px;
                    font-weight: bold;
                }
                .system {
                    margin: 5px 0 0;
                    height: 30px;
                    line-height: 30px;
                    color: #fff;
                    font-size:14px;
                    letter-spacing: 0.2px;
                    .right {
                        margin-left: 10px;
                    }
                }
                .prompt1 {
                    height: 15px;
                    line-height: 15px;
                    color: #fff;
                    font-size:16px;
                    color: #ffb90f;
                    letter-spacing: 0.2px;
                }
                .btn {
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    align-items: center;
                    margin-top: 8px;
                    height: 60px;
                    width: 280px;
                    .stand-alone, .cloud {
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        width: 130px;
                        height: 60px;
                        background: #00cd00;
                        border-radius: 5px;
                        text-decoration: none;
                        cursor: pointer;
                        .version-type {
                            display: flex;
                            flex-direction: row;
                            color: #fff;
                            font-size: 20px;
                            font-weight: bold;
                            letter-spacing: 0.5px;
                            img {
                                margin-left: 5px;
                                width: 25px;
                                height: 25px;
                            }
                        }
                        .version {
                            color: #fff;
                            font-size: 14px;
                        }
                    }
                }
                .applets {
                    margin-top: 8px;
                    width: 100px;
                    height: 100px;
                    border-radius: 8px;
                    cursor: pointer;
                }
                .remark {
                    display: block;
                    margin: 8px 0 0 5px;
                    color: #000;
                    font-size: 15px;
                    font-weight: bold;
                    text-decoration: none;
                    border-bottom: 1.5px solid #ffb90f;
                    cursor: pointer;
                    span {
                        color: #ffb90f;
                        font-size: 16px
                    }
                }
                .teaching-video {
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;
                    margin-top: 8px;
                    width: 300px;
                    height: 40px;
                    background: #e7f2fe;
                    border-radius: 8px;
                    .left, .right {
                        flex: 1;
                        height: 40px;
                        line-height: 40px;
                        font-size: 14px;
                        text-align: center;
                        color: #000;
                        text-decoration: none;
                        cursor: pointer;
                        img {
                            margin-bottom: -5px;
                            width: 20px;
                            height: 20px;
                        }
                    }
                    .left {
                        background: #cae2f9;
                        border-radius: 8px;
                    }
                }
            }
            .change-carousel {
                margin-left: 0;
            }
        }
    }
}
</style>
